import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Message, SpinnerService } from 'shared-components';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { EtiquetadoService } from "../../../services/etiquetado.service";
import { Subject } from 'rxjs';
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-confecciones-reutilizada-component',
    templateUrl: './confeccion-reutilizada.component.html'
})
export class ConfeccionReutilizadaComponent implements OnInit {

    private _confeccionReutilizaCajas;

    public reutilizaForm: UntypedFormGroup;

    public showError: boolean;
    public mensajes = new Array<Message>();

    public tipoConfeccionList = [
        {
            id: 1,
            des: this._translate.instant('mantenimientoConfecciones.confeccion.tipos.caja')
        },
        {
            id: 2,
            des: this._translate.instant('mantenimientoConfecciones.confeccion.tipos.pallet')
        }
    ];

    @Input() confeccionCaja;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() mensaje = new EventEmitter<string>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _etiquetadoService: EtiquetadoService,
        private readonly _dataProvider: DataProvider,
        private readonly _translate: TranslateService
    ) {}

    ngOnInit() {
        this.reutilizaForm = this._fb.group({
            des: ['', Validators.required],
            alias: [''],
            tipoConfeccion: [{ value: this.tipoConfeccionList.find(x => x.id === 2), disabled: true }, Validators.required],
            numCajas: [1, Validators.required]
        });
    }

    public get etiquetadores() {
        return this._dataProvider.etiquetadores;
    }

    public close() {
        this.refresh.emit(false);
    }

    public createConfeccionReutilizaCajas() {
        this.checkForm();
        if (this.reutilizaForm.valid) {
            this._confeccionReutilizaCajas = {
                des: this.reutilizaForm.get('des').value ? this.reutilizaForm.get('des').value : '',
                alias: this.reutilizaForm.get('alias').value ? this.reutilizaForm.get('alias').value : '',
                tipoConfeccionId: this.reutilizaForm.get('tipoConfeccion').value ? this.reutilizaForm.get('tipoConfeccion').value.id : '',
                lsCajas: [
                    {
                        cajaId: this.confeccionCaja.cajasConfeccion[0].cajaId,
                        numCajas: this.reutilizaForm.get('numCajas').value
                    }
                ]
            };
            this._spinnerService.showSpinner();
            this._etiquetadoService.createConfeccionReutilizaCajas(this._confeccionReutilizaCajas).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then(
                (resp) => {
                    this.refresh.emit(true);
                    this.mensaje.emit('global.success.itemUpdated');
                },
                (error) => {
                    this.showError = true;
                    this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                }
            );
        }
    }

    private checkForm() {
        this.showError = this.reutilizaForm.invalid;
        if (this.showError) {
            this.mensajes.push({ class: 'error', message: 'global.error.required' });
        }
    }


}
